
import { defineComponent } from "vue";
import { isFacelessReelPreviewUser } from "@/utils/facelessReelPreview.js";

const ALL_FEATURES = [
  {
    title: "CRM built for your business",
    description:
      "Track every prospect in one place. Contacts from Messenger, forms, and campaigns land automatically in your CRM.",
    icon: "media/icons/duotone/Communication/Address-card.svg",
    tab: "prospects",
    cta: "View Prospects"
  },
  {
    title: "Lead Scoring",
    description:
      "Every prospect is scored and graded Hot, Warm, or Cold from contact details, conversation activity, and buying intent — so you know who to follow up with first.",
    icon: "media/icons/duotone/Shopping/Chart-line1.svg",
    tab: "prospects",
    cta: "See Lead Scores"
  },
  {
    title: "One post. Your whole team’s reach.",
    description:
      "Create content once in this portal and Social Fan-out publishes it straight to your downline’s connected Facebook and Instagram pages — their accounts, your message. Scale team marketing without asking everyone to post manually.",
    icon: "media/icons/duotone/Communication/Group.svg",
    tab: "social",
    cta: "Social Fan-out"
  },
  {
    title: "AI that replies for you",
    description:
      "Connect Messenger and let AI Agents answer common questions instantly — even while you sleep.",
    icon: "media/icons/duotone/Communication/Chat5.svg",
    tab: "ai-agents",
    cta: "Manage AI Agents"
  },
  {
    title: "Smart follow-up",
    description:
      "When a prospect goes quiet, automated follow-ups bring the conversation back without manual chasing.",
    icon: "media/icons/duotone/Communication/Mail-at.svg",
    tab: "ai",
    cta: "AI Settings"
  },
  {
    title: "Your knowledge, their answers",
    description:
      "Build a Knowledge Base with your FAQs, product info, and scripts so AI replies sound like you, not a generic bot.",
    icon: "media/icons/duotone/General/Thunder.svg",
    tab: "knowledge-bases",
    cta: "Knowledge Base"
  },
  {
    title: "Questions your AI could not answer",
    description:
      "Review gaps in your Knowledge Base and add documents or links so the AI can answer similar questions next time.",
    icon: "media/icons/duotone/Communication/Question-square.svg",
    tab: "unanswered-questions",
    cta: "Unanswered Questions"
  },
  {
    title: "Publish from one place",
    description:
      "Schedule and fan out content to Facebook and Instagram from this portal — no switching between tools.",
    icon: "media/icons/duotone/General/Clipboard.svg",
    tab: "publish",
    cta: "Publish Content"
  },
  {
    title: "Faceless Reels generator",
    description:
      "In Publish Content, choose Facebook Reel, pick a product and AI voice, generate a compliant script, then create a vertical video with voiceover — about 30 seconds, ready to post.",
    icon: "media/icons/duotone/Media/Playlist1.svg",
    tab: "publish",
    cta: "Create a Reel",
    previewOnly: true
  }
];

export default defineComponent({
  name: "ai247-explanation",
  emits: ["navigate"],
  computed: {
    features() {
      if (isFacelessReelPreviewUser()) {
        return ALL_FEATURES;
      }
      return ALL_FEATURES.filter((item) => !item.previewOnly);
    }
  }
});
